document.addEventListener("DOMContentLoaded", function () {
	const faqContainers = document.querySelectorAll(".faq-items");

	faqContainers.forEach((container) => {
		const items = container.querySelectorAll(".faq-item");

		items.forEach((item) => {
			const toggle = item.querySelector(".faq-title");
			const content = item.querySelector(".faq-content");
			if (!toggle || !content) return;

			toggle.setAttribute("aria-expanded", "false");
			content.setAttribute("aria-hidden", "true");

			toggle.addEventListener("click", () => {
				const isOpen = item.classList.toggle("active");
				toggle.setAttribute("aria-expanded", String(isOpen));
				content.setAttribute("aria-hidden", String(!isOpen));
			});
		});
	});
});
